module.exports = __webpack_public_path__ + "assets/img/step6-sz.80a4fa06.png";